import { InvalidMineralError } from '../../domain/errors/InvalidMineralError';
import type { MineralsRepository } from '../../domain/repositories/MineralsRepository.interface';
import type { MineralDto } from '../dto/MineralDto';
import { ApplicationError, type Logger } from '@dma/shared';

export class GetMineralsUseCase {
  constructor(
    private readonly repository: MineralsRepository,
    private readonly logger: Logger
  ) {}

  public async execute(): Promise<MineralDto[]> {
    try {
      const minerals = await this.repository.getAll();
      return minerals.map((mineral) => mineral.props);
    } catch (error) {
      if (error instanceof InvalidMineralError) {
        this.logger.error('Minerals content failed domain validation', {
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('MINERALS_UNAVAILABLE', 'فهرست محصولات در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
